export default __webpack_public_path__ + "static/media/register.847805e7.jpg";